module.exports = __webpack_public_path__ + "img/logoBANCOLOMBIA.825960f6.png";